/**
 * When a convoy and its shadow stop on the same patch of road, labels
 * stack. Flip sides in a cell, and drop to icon-only once the cell is
 * crowded — hover still has the name.
 */
export type PinLabelSide = 'left' | 'right' | 'center' | 'hidden';

export function pinCell(latitude: number, longitude: number): string {
  return `${latitude.toFixed(4)}:${longitude.toFixed(4)}`;
}

export function pinLabelSide(
  items: Array<{ id: string; latitude: number; longitude: number }>,
  id: string,
  prefer: 'left' | 'right' | 'center' = 'right',
): PinLabelSide {
  const me = items.find((item) => item.id === id);
  if (!me) return 'center';
  const cell = pinCell(me.latitude, me.longitude);
  const cluster = items.filter((item) => pinCell(item.latitude, item.longitude) === cell);
  if (cluster.length >= 4) return 'hidden';
  if (cluster.length < 2) return prefer;
  const index = cluster.findIndex((item) => item.id === id);
  if (index % 2 === 0) return prefer;
  if (prefer === 'right') return 'left';
  if (prefer === 'left') return 'right';
  return 'left';
}

export function pinLabelSx(side: PinLabelSide): Record<string, unknown> {
  if (side === 'hidden') return { display: 'none' };
  if (side === 'left') return { left: 'auto', right: 22, transform: 'none' };
  if (side === 'right') return { left: 22, transform: 'none' };
  return { left: '50%', transform: 'translateX(-50%)' };
}
